module.exports = {
  pleaseWait: 'សូមរង់ចាំ',
  loading: 'កំពុងដំណើរការ',
  Billing: 'វិក័យប័ត្រ',
  billingTips: 'ប្រវត្តិទិញរបស់អ្នក',
  ID: 'លេខសម្គាល់',
  FAQ: 'សំណួរគេសួរញឹកញាប់',
  TC: 'លក្ខខណ្ឌប្រើប្រាស់សេវាកម្ម',
  Copyright: '© 2026 រក្សាសិទ្ធិគ្រប់យ៉ាង',
  GenerateImage: 'បង្កើតរូបភាព',
  generateTips1: 'កម្មវិធីបង្កើតរូបភាពដោយ AI របស់យើង អាចនាំឲ្យការស្រមៃរបស់អ្នកក្លាយជាការពិតបាន នៅក្នុងរយៈពេលប៉ុន្មានវិនាទីប៉ុណ្ណោះ។ វាអាចបង្កើតស្នាដៃសិល្បៈគួរឱ្យទាក់ទាញ រូបគំនូរ និងរូបថតបានយ៉ាងឆាប់រហ័ស។ បញ្ចេញនូវសិល្បៈច្នៃប្រឌិតរបស់អ្នក ហើយបង្ហាញខ្លួនអ្នកតាមរយៈវិធីថ្មីៗជាមួយអំណាចនៃ AI។ ស្វែងរកនូវលទ្ធភាពគ្មានដែនកំណត់ ចាប់ពីការច្នៃប្រឌិតសារផ្សព្វផ្សាយដ៏មានឯកត្តភាព ដល់ការបង្កើតស្នាដៃសិល្បៈដ៏ស្រស់ស្អាត ទាំងអស់បានយ៉ាងងាយស្រួល និងមានប្រសិទ្ធភាព',
  generateTips2: 'បញ្ចូលពាក្យពីរបីខាងក្រោម ហើយមើល Snapai បំប្លែងអត្ថបទទៅជាសិល្បៈមិនគួរឱ្យជឿ',
  Prompt: 'ជម្រុញ',
  PromptTips1: 'ប្រាប់ AI ពីអ្វីដែលត្រូវគូរ',
  PromptTips2: 'គន្លឹះ៖ ពិពណ៌នាអំពីអារម្មណ៍ និងពន្លឺ។ សូមមើលការណែនាំទំព័រសម្រាប់ច្រើនទៀត',
  PromptTips3: 'បញ្ជាក់៖ AI ប្រហែលជាមិនធ្វើតាមការណែនាំ និងមិនអាចរាប់បានទេ។',
  Generate: 'បង្កើត',
  ChancesLeft: 'ឱកាសនៅសល់',
  BuyChances: 'ទិញឱកាសបន្ថែម',
  generateImageTips1: 'បញ្ចូលអ្វីដែលអ្នកចង់បាន',
  generatePromptsTips1: 'បញ្ចូលអ្វីដែលអ្នកមិនចង់បាន',
  indexTips1: 'ឱកាសឥតគិតថ្លៃប្រចាំថ្ងៃ <br /> មាន!',
  indexTips2: 'ជ្រើសរើសមួយក្នុងចំណោមទាំងនេះ',
  ImageRestorer: 'ស្តាររូបភាព',
  Continue: 'បន្ត',
  language0: 'ភាសា',
  language: 'រើសភាសា',
  languageTips: 'រើសភាសារបស់អ្នកនៅទីនេះ',
  Submit: 'ដាក់ស្នើ',
  change: 'ផ្លាស់ប្តូរ',
  English: 'អង់គ្លេស',
  Myanmar: 'មីយ៉ាន់ម៉ា',
  Cambodia: 'ខ្មែរ',
  Login: 'ចូល',
  Logout: 'ចាកចេញ',
  getCode: 'ផ្ញើឡើងវិញ',
  loginTips: 'បញ្ចូលលេខទូរស័ព្ទ',
  profile: 'ប្រវត្តិរូប',
  phoneNumber: 'លេខទូរស័ព្ទ',
  SubscribedSince: 'ភ្ជាប់តាំងពី',
  RemainingChances: 'ឱកាសដែលនៅសល់',
  cgtips2: 'ត្រឹមតែ $0.10/ថ្ងៃ<br />សូមចុច OK ដើម្បីភ្ជាប់',
  cgtips2W: 'ត្រឹមតែ $0.60/សប្ដាហ៍<br />សូមចុច OK ដើម្បីភ្ជាប់',
  cgtips2M: 'ត្រឹមតែ $2/ខែ<br />សូមចុច OK ដើម្បីភ្ជាប់',
  OK: 'យល់ព្រម',
  PictureRestorer: 'ស្តាររូបភាព',
  PictureTips1: 'ស្តារ ធ្វើឱ្យច្បាស់ និងជួសជុលរូបភាពដោយប្រើ AI ។ Snapai បង្កើតការស្រាវជ្រាវចុងក្រោយបង្អស់ ដើម្បីលុបស្នាមឆ្កូតចេញដោយស្វ័យប្រវត្តិ ធ្វើឱ្យច្បាស់ពណ៌ និងធ្វើឱ្យមុខប្រសើរឡើង បំលែងរូបថតដែលខូចទៅជាអនុស្សាវរីយ៍គួរឱ្យស្រឡាញ់។ សេវាជួសជុលដោយឥតគិតថ្លៃ ទាំងរូបថតពណ៌ និងសខ្មៅ',
  Upload: 'បង្ហោះ',
  PictureTips2: 'បានកោស?',
  Restore: 'ស្តារ',
  uploadTips: 'សូមបង្ហោះរូបភាព',
  photoReadFailed: 'មិនអាចបើករូបភាពនេះបានទេ។ សូមជ្រើសរើសរូប JPG, PNG ឬ WebP ដែលបានរក្សាទុកក្នុងឧបករណ៍។',
  photoTooLarge: 'រូបភាពក្រោយកែច្នៃមានទំហំធំពេក។ សូមជ្រើសរើសរូបភាពផ្សេង។',
  PurchaseChances: 'ទិញឱកាស',
  History: 'ប្រវត្តិ',
  purchaseTips1: 'ឱកាសសរុបរបស់អ្នក។',
  purchaseTips2: 'ការទិញតែម្តង',
  Daily: 'ប្រចាំថ្ងៃ',
  Weekly: 'ប្រចាំសប្តាហ៍',
  OneTime: 'តែម្តង',
  Purchase: 'ទិញ',
  DailyKyats: '$0.10/ថ្ងៃ',
  WeeklyKyats: '$0.60/សប្ដាហ៍',
  OneTimeChance: '$0.1/2 ឱកាសសម្រាប់ប្រើប្រាស់ eMoneySnapAI',
  FiveTimeChance: '$0.2/5 ឱកាសសម្រាប់ប្រើប្រាស់ eMoneySnapAI',
  TenTimeChance: '$0.35/10 ឱកាសសម្រាប់ប្រើប្រាស់ eMoneySnapAI',
  Subscribe: 'ភ្ជាប់',
  purchaseTips3: 'សូមជ្រើសរើសចំនួន <strong>ឱកាស</strong>ដើម្បីទិញ។',
  BuyNow: 'ទិញឥឡូវនេះ',
  logout: 'ចាកចេញ',
  petTitle1: 'AI តុក្ដតា Anime សត្វចិញ្ចឹម',
  petTitle2: 'រើសរចនាបទ',
  petContent1: 'បំប្លែង​រូបថត​សត្វ​ចិញ្ចឹម​ជា​ទី​ស្រឡាញ់​របស់​អ្នក​ទៅ​ជា​ស្នាដៃ​តុក្ដតា Anime ​ដ៏​អស្ចារ្យ។ ល្អឥតខ្ចោះសម្រាប់អ្នកស្រឡាញ់សត្វចិញ្ចឹម និងអ្នកចូលចិត្តតុក្ដតា Anime Snapai ផ្តល់នូវវិធីសប្បាយៗ និងផ្ទាល់ខ្លួនដើម្បីអបអរដល់មិត្តភក្តិដែលមានរោមសត្វរបស់អ្នក',
  sexTitle1: 'AI រូបតុក្កតាផ្ទាល់ខ្លួន',
  sexTitle2: 'ជ្រើសរើសភេទ',
  sexContent1: 'នាំមកនូវការស្រមើស្រមៃរបស់អ្នកដល់ជីវិតដោយបង្កើតរូបថតបែបតុក្ដតា Anime ដោយផ្អែកលើការសរសេរ។ មិនថាអ្នកជាអ្នកគាំទ្រតុក្ដតា Anime អ្នកនិទានរឿង ឬអ្នករចនាទេ AI រូបសត្វ ផ្តល់អំណាចឱ្យអ្នកបង្កើតរូបភាពបែបតុក្ដតា Animeដែលមានគុណភាពខ្ពស់ប្រកបដោយភាពរស់រវើកដោយលាយបញ្ចូល AI កម្រិតខ្ពស់ជាមួយនឹងចក្ខុវិស័យតែមួយរបស់អ្នក។',
  sexContent2: 'ជ្រើសរើសភេទខាងក្រោម ហើយបញ្ចូលប្រអប់បញ្ចូលខាងក្រោម។ មើល Snap Ai បំលែងអត្ថបទទៅជាសិល្បៈមិនគួរឱ្យជឿ',
  Female: 'ស្រី',
  Male: 'ប្រុស',
  Style1: 'រចនាបទ​ 1',
  Style2: 'រចនាបទ 2',
  Style3: 'រចនាបទ 3',
  Comic: 'រឿងកំប្លែង',
  Disney: 'Disney',
  Ghibli: 'Ghibli',
  Animalanime: 'តុក្ដតា Anime Selfie',
  HumanAnime: 'តុក្ដតា Anime មនុស្ស',
  Guidance: 'ការណែនាំ',
  PetAnime: 'តុក្ដតា Anime សត្វចិញ្ចឹម',
  landTips1: 'បង្កើតរូបថតគួរឱ្យភ្ញាក់ផ្អើល &',
  landTips2: 'ឈ្នះរង្វាន់ធំ!',
  landTips3: 'ផ្លាស់ប្តូរការស្រមើលស្រមៃរបស់អ្នកឱ្យក្លាយជាការពិតជាមួយ SnapAI! ពីការបង្កើតរូបថតដ៏អស្ចារ្យរហូតដល់ស្នាដៃសិល្បៈ SnapAI ផ្តល់អំណាចឱ្យអ្នកបង្កើតរូបភាពដែលមិនធ្លាប់មានពីមុនមក។ ចូលទៅក្នុងពិភពនៃលទ្ធភាពគ្មានដែនកំណត់',
  show401tip: 'ទឹកប្រាក់មិនគ្រប់គ្រាន់',
  show400dailytip: 'អស់ពេល សូមផ្ញើ "ON1" ទៅកាន់លេខ 1548 ដើម្បីឈ្នះរង្វាន់ធំ',
  show400weeklytip: 'អស់ពេល សូមផ្ញើ "ON7" ទៅកាន់លេខ 1548 ដើម្បីឈ្នះរង្វាន់ធំ',
  register: 'ភ្ជាប់​',
  invitation: 'ការអញ្ជើញ',
  invitationTips: 'ចម្លង និងផ្ញើការអញ្ជើញដោយប្រើតំណខាងក្រោម',
  InviteNow: 'អញ្ជើញឥឡូវនេះ',
  copySuccess: 'ចម្លងជោគជ័យ!',
  process: 'ការបង្កើត',
  downTips1: 'សូមចម្លងតំណទៅក្នុងកម្មវិធី​ Brower ហើយទាញយក',
  downloadImage: 'ទាញយករូបភាព',
  downloadImageTips: 'ចុច ទាញយក ដើម្បីរក្សាទុករូបភាព។',
  copyLink: 'ចម្លងតំណ',
  free: 'ឥតគិតថ្លៃ',
  aiAnimeTitle: 'AI គំនូរជីវចលគូ',
  aiAnimeCt1: 'បំប្លែងរូបថតគូស្នេហ៍ដើមរបស់អ្នកទៅជារូបភាពបែបតុក្ដតា Anime ធ្វើឱ្យការចងចាំមនោសញ្ចេតនារបស់អ្នកកាន់តែរីករាយ។ មិនថាអ្នកជាអ្នកចូលចិត្តរូបតុក្កតា ឬអ្នករចនា អនុញ្ញាតឱ្យអ្នកបង្កើតរូបភាពបែបរូបតុក្កតាប្រកបដោយអត្ថន័យ និងគុណភាពខ្ពស់ដោយមិនចាំបាច់ប្រឹងប្រែង ដោយលាយបញ្ចូលគ្នាយ៉ាងល្អឥតខ្ចោះនូវបច្ចេកវិទ្យា AI កម្រិតខ្ពស់ជាមួយនឹងគ្រាមនោសញ្ចេតនារបស់អ្នក។',
  aiAnimeCt2: 'ជ្រើសរើសរចនាបទខាងក្រោម ហើយបង្ហោះរូបថតដើមរបស់អ្នកដើម្បីមើល Snapai បំលែងអនុស្សាវរីយ៍ដ៏ផ្អែមល្ហែមរបស់អ្នកទៅជាស្នាដៃសិល្បៈដ៏អស្ចារ្យ.',
  comingsoonT: 'ឆាប់ៗនេះ',
  SubscribePackage: 'ភ្ជាប់កញ្ចប់',
  landfont1: 'ប្រែក្លាយរូបថតទៅជាស្នាដៃសិល្បៈតុក្ដតា Anime​ ដ៏អស្ចារ្យ',
  landfont2: 'ផ្លាស់ប្តូររូបថតគូស្នេហ៍របស់អ្នកទៅជាតួអង្គតុក្ដតា Animeដ៏ស្រស់ស្អាត',
  landfont3: 'សរសេរប្រអប់បញ្ចូលដើម្បីបង្កើតរូបភាពដ៏ស្រស់ស្អាត',
  landfont4: 'ប្រែក្លាយសត្វចិញ្ចឹមរបស់អ្នកទៅជាតួអង្គគំនូរជីវចលដ៏គួរឱ្យស្រឡាញ់ជាមួយនឹងវេទមន្ត AI!',
  landfont5: 'ស្វែងរកការចងចាំរបស់អ្នកឡើងវិញជាមួយនឹងការស្តាររូបថតដែលដំណើរការដោយ AI ។',
  SmartCutout: 'កាត់រូបឆ្លាតវៃ',
  letgo: 'តោះទៅ',
  IpIMage: 'រូបថតអត្តសញ្ញាណ',
  IpIMageTip: 'ត្រូវ​ការ​អាជ្ញាប័ណ្ណ ឬ​រូបថត​អត្តសញ្ញាណ​ដែល​បាន​បង្កើត​? យើងបានគ្របដណ្ដប់អ្នក!',
  IpIMage_content: 'រូបភាពដើមដែលបានផ្ទុកឡើងសម្រាប់រូបថតអត្តសញ្ញាណត្រូវតែធានាថាមុខរបស់មនុស្សគឺច្បាស់ដោយគ្មានការរារាំងណាមួយឡើយហើយស្មាគឺស្មើនិងស្មើ។ បើមិនដូច្នោះទេជំនាន់អាចបរាជ័យ',
  snapbot: 'SnapBot',
  snapbot_hi: 'សួស្តី ខ្ញុំគឺ SnapBot',
  help_today: 'តើខ្ញុំអាចជួយអ្នកនៅថ្ងៃនេះដោយរបៀបណា?',
  think_ip: '🤖 ការគិត...',
  Coloring_old_photos: 'ផ្លាស់ប្តូរពណ៌រូបភាព',
  Coloring_old_photos_tips: 'ធ្វើឱ្យការចងចាំរបស់អ្នកមានជីវិតឡើងវិញដោយការស្តារពណ៌\n' +
    'ទៅកាន់រូបថតបុរាណរបស់អ្នក។ ឧបករណ៍ដែលដំណើរការដោយ AI របស់យើង\n' +
    'វិភាគ និងបន្ថែមពណ៌ធម្មជាតិដោយស្វ័យប្រវត្តិ\n' +
    'រក្សាភាពទាក់ទាញនៃដើមខណៈពេលដែល\n' +
    'បង្កើនភាពទាក់ទាញដែលមើលឃើញរបស់វា។\n',
  Coloring_old_photos_tips2: 'យករូបថតចាស់ៗរបស់អ្នកឱ្យរស់រវើកជាមួយនឹងការស្តារពណ៌ដែលដំណើរការដោយ AI',
  BgFusion: 'ការលាយបញ្ចូលយ៉ាងឆ្លាតវៃ',
  BgFusion_tips2: 'ប្ដូររូបថតរបស់អ្នកតាមបំណងជាមួយនឹងផ្ទៃខាងក្រោយនៃជម្រើសរបស់អ្នក',
  BgFusion_tips: 'ប្ដូររូបថតរបស់អ្នកតាមបំណងជាមួយនឹងផ្ទៃខាងក្រោយនៃជម្រើសរបស់អ្នក។\n' +
    'ប្ដូររូបថតរបស់អ្នកតាមបំណងជាមួយនឹងផ្ទៃខាងក្រោយនៃជម្រើសរបស់អ្នក\n' +
    'និងលាយរូបភាពរបស់អ្នកតាមធម្មជាតិទៅក្នុងឈុតថ្មី',
  Upload_bg: 'ផ្ទុកឡើងផ្ទៃខាងក្រោយ',
  Upload_pt: 'បង្ហោះរូបបញ្ឈរ',
  Recolor: 'ផ្លាស់ប្តូរពណ៌',
  snapbotTips1: 'លទ្ធផលស្វែងរករហ័ស',
  snapbotTips2: 'ដំណើរការភាសាធម្មជាតិ',
  snapbotTips3: 'ការវិភាគទិន្នន័យធំ',
  snapbotTips4: 'ក្បួនដោះស្រាយដំណើរការដោយ AI',
  snapbotInput1: 'ចុចទីនេះដើម្បីចាប់ផ្តើមជាមួយ SnapBot',
  white: 'ស',
  blue: 'ខៀវ',
  '1 inch': '1 អ៊ីញ',
  '2 inches': '2 អ៊ីញ',
  '3 inches': '3 អ៊ីញ',
  landTips11: 'បង្កើតរូបថតដ៏អស្ចារ្យ &',
  ChangeHairstyle: 'បែបបទម៉ូដសក់វេទមន្ត',
  ChangeHairstyle_short: 'បង្កើត​និង​សាកល្បង​ម៉ូដ​សក់​ដែល​អ្នក​ស្រមៃ​អ្នក',
  ChangeHairstyle_content_1: 'កម្មវិធី snapai ផ្តល់នូវលក្ខណៈពិសេសមួយសម្រាប់ការផ្លាស់ប្តូរម៉ូតសក់ ដែលអនុញ្ញាតឱ្យអ្នកប្រើប្រាស់សាកល្បងកាត់សក់ផ្សេងៗគ្នាក្នុងពេលវេលាជាក់ស្តែង ឬតាមរយៈរូបថតដែលបានបង្ហោះ។ មុខងារនេះប្រើប្រាស់បច្ចេកវិទ្យា AI ដើម្បីវិភាគទម្រង់មុខរបស់អ្នកប្រើប្រាស់ និងណែនាំម៉ូដសក់ដែលសាកសមនឹងទម្រង់មុខ ចំណូលចិត្ត និងរចនាបទរបស់ពួកគេ។ អ្នកប្រើប្រាស់អាចសាកល្បងជាមួយនឹងរូបរាងផ្សេងៗ រាប់ចាប់ពីការផ្លាស់ប្ដូរបន្តិចបន្តួចរហូតដល់ការផ្លាស់ប្តូរយ៉ាងដិតដល់ និងអស្ចារ្យដោយផ្តល់ឱ្យពួកគេនូវការមើលជាមុននិម្មិត មុនពេលធ្វើការផ្លាស់ប្តូរជាក់ស្តែង។ កម្មវិធីនេះផ្តល់នូវវិធីងាយស្រួល និងរីករាយសម្រាប់អ្នកប្រើប្រាស់ក្នុងការស្វែងរកម៉ូដសក់ផ្សេងៗគ្នា និងស្វែងរកអ្វីដែលល្អឥតខ្ចោះសម្រាប់ពួកគេ។',
  ChangeHairstyle_content_2: 'ជ្រើសរើសម៉ូដសក់ដែលអ្នកចូលចិត្តខាងក្រោម ហើយបន្ថែមរូបថតផ្ទាល់ខ្លួនរបស់អ្នក។ អ្នកនឹងទទួលបានរូបភាពដ៏ស្រស់ស្អាត និងច្បាស់',
  Result: 'លទ្ធផល',
  Original: 'កំណែដើម',
  unsub_tip: 'ដើម្បីផ្ដាច់​ ផ្ញើ OFF​ ទៅ 1548 ',
  sub_tip: 'ដើម្បីភ្ជាប់​ ផ្ញើ "ON1" ឬ "ON7" 1548',
  longHairEffects: 'បែបផែនសក់វែង',
  longHairEffects_tip: 'សាកល្បងបែបផែនសក់វែង វាផ្តល់ឱ្យអ្នកនូវស្ទីលម៉ូដសក់ធម្មជាតិ និងទាក់ទាញ។ ឥទ្ធិពលនេះបង្កើតរូបរាងសក់វែងសម្រាប់អ្នក\n' +
    'រលោង & ភ្លឺ\n' +
    'ប្រវែងដែលមើលទៅធម្មជាតិ\n' +
    'ល្អឥតខ្ចោះសម្រាប់សម្លៀកបំពាក់ណាមួយ អ្នកមើលទៅល្អបំផុតជារៀងរាល់ថ្ងៃជាមួយនឹងបែបផែនសក់វែង!',
  VIDEO: 'វីដេអូ',
  Yes: 'បាទ',
  Monthly: 'ប្រចាំខែ',
  select_package: 'សូមជ្រើសរើសកញ្ចប់',
  all_package: 'កញ្ចប់ទាំងអស់។',
  daily_package: 'កញ្ចប់ប្រចាំថ្ងៃ',
  weekly_package: 'កញ្ចប់ប្រចាំសប្តាហ៍',
  monthly_package: 'កញ្ចប់ប្រចាំខែ',
  best_choice: 'ណែនាំ',
  chances_2_day: "2 ឱកាសសម្រាប់ការប្រើប្រាស់ eMoneySnapAI / ថ្ងៃ។",
  chances_14_day: '14 ឱកាសសម្រាប់ការប្រើប្រាស់ eMoneySnapAI / 7 ថ្ងៃ។',
  chances_60_day: '60 ឱកាសសម្រាប់ការប្រើប្រាស់ Metfone napAI / 30 ថ្ងៃ។',
  subscribeNow: 'ជាវ',
  free_first_sub: 'ឥតគិតថ្លៃសម្រាប់ការចុះឈ្មោះដំបូង',
  home: 'ផ្ទះ',
  UNSUBSCRIBE: 'ឈប់ជាវ',
  LOGOUT: 'ចេញពីប្រព័ន្ធ',
  buy_tip1: '0.1 USD / ទទួលបាន 2 ឱកាសសម្រាប់ការប្រើប្រាស់ eMoneySnapAI',
  buy_tip2: '0.2 USD / ទទួលបាន 5 ឱកាសសម្រាប់ការប្រើប្រាស់ eMoneySnapAI',
  buy_tip3: '0.35 USD / ទទួលបាន 10 ឱកាសសម្រាប់ការប្រើប្រាស់ eMoneySnapAI',
  style: 'រចនាប័ទ្ម',
  smart_cutout: "លុបផ្ទាំងខាងក្រោយ",
  smart_cutout_tip: "លុបផ្ទៃខាងក្រោយចេញពីរូបថតរបស់អ្នក។",
  smart_cutout_desc: "មុខងារលុបផ្ទៃខាងក្រោយអនុញ្ញាតឱ្យអ្នកប្រើប្រាស់លុប ឬផ្លាស់ប្តូរផ្ទៃខាងក្រោយនៃរូបភាពណាមួយបានយ៉ាងងាយស្រួល ជាមួយនឹងភាពជាក់លាក់ដែលដំណើរការដោយ AI។ មិនថាអ្នកកំពុងបង្កើតរូបថតផលិតផលប្រកបដោយវិជ្ជាជីវៈ ការបង្ហោះប្រព័ន្ធផ្សារភ្ជាប់សង្គមសប្បាយៗ ឬការកែសម្រួលសិល្បៈទេ ឧបករណ៍នេះធានានូវការកាត់ចេញបានស្អាតដោយគ្រាន់តែចុចតែម្តង។",
  Choose_background: "ជ្រើសរើសផ្ទៃខាងក្រោយ",
  Choose_size: "ជ្រើសរើសទំហំ",
  redirect_tip: 'သင့်အား ဘရောက်ဆာသို့ ပြန်လည်ညွှန်းပေးပါမည်။',
  copy_project_url: 'ចម្លងតំណ ហើយបើកវានៅក្នុងកម្មវិធីរុករករបស់អ្នក ដើម្បីបង្ហោះរូបភាព',
  CopySucceeded: 'ចម្លងបានជោគជ័យ',
  payment_failed_retry: 'ការទូទាត់បរាជ័យ សូមព្យាយាមម្តងទៀត',
  resub_tip: 'គណនីរបស់អ្នកត្រូវបានឈប់ជាវ។ អ្នកអាចជ្រើសរើសបន្តចូល ឬជាវឡើងវិញមុនពេលរយៈពេលសុពលភាពផុតកំណត់។',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js